module.exports = __webpack_public_path__ + "static/media/mercadopago.56713db2.svg";